import { PaymentCaseType } from 'types/payments'

export const paymentCaseTypeFilterOptions: PaymentCaseType[] = [
  PaymentCaseType.NEW,
  PaymentCaseType.UNRESOLVED,
  PaymentCaseType.IN_PROGRESS,
  PaymentCaseType.RESOLVED,
]
